<template>
	<div class="chat-welcome">
		<div class="chat-welcome-icon">
			<GuIAreGlyph :size="56" />
		</div>

		<h2 class="chat-welcome-title">
			Oi, eu sou a <span class="chat-welcome-brand">gu<span class="chat-welcome-ia">IA</span>re</span> 👋
		</h2>
		<!-- eslint-disable-next-line vue/no-v-html -->
		<p class="chat-welcome-desc" v-html="descHtml"></p>

		<div class="chat-welcome-divider">
			<span>Experimente</span>
		</div>

		<div class="chat-welcome-suggestions">
			<button
				v-for="(s, i) in suggestions"
				:key="i"
				type="button"
				class="chat-welcome-chip"
				@click="$emit('suggest', s)"
			>
				<v-icon size="14" :color="$corIcone" class="mr-1">mdi-sparkles</v-icon>
				{{ s }}
			</button>
		</div>

		<p class="chat-welcome-footer">
			<v-icon size="12" color="#94a3b8" class="mr-1">mdi-shield-check-outline</v-icon>
			{{ footerText }}
		</p>
	</div>
</template>

<script>
import GuIAreGlyph from './GuIAreGlyph.vue';
import { chatPersona } from '@/utils/guiareAccess';

export default {
	name: 'ChatWelcome',

	components: { GuIAreGlyph },

	props: {
		suggestions: {
			type: Array,
			default: () => [],
		},
	},

	computed: {
		// São três personas. Tratar como "condômino ou o resto" fazia o síndico
		// receber o texto da construtora, prometendo dados que ele não vê.
		persona() {
			return chatPersona();
		},

		descHtml() {
			if (this.persona === 'condomino') {
				return 'Sua assistente aqui do seu imóvel. Posso ajudar com '
					+ '<strong>chamados de assistência técnica, manuais e documentos</strong>'
					+ ' — sem precisar procurar em vários lugares.';
			}

			if (this.persona === 'sindico') {
				return 'Sua assistente aqui do condomínio. Posso ajudar com o '
					+ '<strong>plano de manutenção preventiva</strong>'
					+ ' — o que está pendente, o que vence e como está a eficiência.';
			}

			return 'Sua assistente de dados do sistema. Posso responder sobre '
				+ '<strong>manuais, manutenção, chamados, databook e custos</strong>'
				+ ' da sua construtora — sem precisar abrir relatório.';
		},

		footerText() {
			const textos = {
				condomino: 'Só vejo dados do seu imóvel. Não falo sobre outros assuntos.',
				sindico: 'Só vejo dados do seu condomínio. Não falo sobre outros assuntos.',
				construtora: 'Só vejo dados da sua construtora. Não falo sobre outros assuntos.',
			};

			return textos[this.persona] || textos.construtora;
		},
	},
};
</script>

<style scoped>
.chat-welcome {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 24px 12px 16px;
	animation: fade-up 400ms ease both;
}

.chat-welcome-icon {
	margin-bottom: 14px;
	animation: glyph-bob 4s ease-in-out infinite;
}

@keyframes glyph-bob {
	0%, 100% { transform: translateY(0); }
	50%      { transform: translateY(-4px); }
}

.chat-welcome-title {
	font-size: 20px;
	font-weight: 700;
	color: #111827;
	margin: 0 0 8px;
}

.chat-welcome-brand {
	display: inline-block;
}

.chat-welcome-ia {
	background: linear-gradient(135deg, #0b1532 0%, #1e3a8a 100%);
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
	font-weight: 900;
	padding: 0 1px;
}

.chat-welcome-desc {
	font-size: 13.5px;
	color: #6b7280;
	line-height: 1.55;
	margin: 0 0 24px;
	max-width: 360px;
}

.chat-welcome-divider {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	margin-bottom: 14px;
}

.chat-welcome-divider::before,
.chat-welcome-divider::after {
	content: '';
	flex: 1;
	height: 1px;
	background: rgba(148, 163, 184, 0.3);
}

.chat-welcome-divider span {
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: #94a3b8;
}

.chat-welcome-suggestions {
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
	margin-bottom: 18px;
}

.chat-welcome-chip {
	border: 1px solid rgba(148, 163, 184, 0.35);
	background: rgba(255, 255, 255, 0.7);
	backdrop-filter: blur(8px);
	border-radius: 10px;
	padding: 8px 12px;
	text-align: left;
	font-size: 12.5px;
	line-height: 1.35;
	color: #111827;
	cursor: pointer;
	transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.chat-welcome-chip:hover {
	transform: translateY(-1px);
	border-color: rgba(var(--color-primary-rgb, 252, 207, 50), 0.6);
	box-shadow: 0 8px 16px -12px rgba(var(--color-primary-rgb, 252, 207, 50), 0.6);
}

.chat-welcome-footer {
	margin: 4px 0 0;
	font-size: 11px;
	color: #94a3b8;
	display: flex;
	align-items: center;
	justify-content: center;
}

@keyframes fade-up {
	from { opacity: 0; transform: translateY(8px); }
	to { opacity: 1; transform: translateY(0); }
}
</style>
